/* eslint-disable max-len */
import { pickManyImports, getDefaultExport, pickManyImportsWithLazyInit, importAfterPreLoad } from './utils';

const resourceMapping = window.routerBundleMapping;

const bundles = {
  StyledAccounts: resourceMapping['/campaign/vnext/accounts'],
  StyledBulkEdits: resourceMapping['/campaign/vnext/bulk-edits'],
  StyledBulkEditsDetail: resourceMapping['/campaign/vnext/bulkeditdetail'],
  MCMCampaignControl: resourceMapping['/campaign/vnext/mcmcampaigncontrol'],
  StyledCompetitionAuctionInsight: resourceMapping['/campaign/vnext/competitionauction'],
  StyledAdGroups: resourceMapping['/campaign/vnext/adgroups'],
  StyledSettingsForm: resourceMapping['/campaign/vnext/settingsform'],
  StyledSettingsSummary: resourceMapping['/campaign/vnext/settingssummary'],
  StyledDevices: resourceMapping['/campaign/vnext/settingscriterion'],
  StyledChangeHistory: resourceMapping['/campaign/vnext/changehistory'],
  StyledKeywordPlanner: resourceMapping['/campaign/vnext/keywordplanner'],
  StyledAdPreview: resourceMapping['/campaign/vnext/adpreview'],
  StyledAdInsightKeywordPlanner: resourceMapping['/research/vnext/keywordplanner'],
  StyledAdInsightAdPreview: resourceMapping['/research/vnext/adpreview'],
  StyledCompetitionRecommendations: resourceMapping['/campaign/vnext/competitionrecommendations'],
  StyledGMBImport: resourceMapping['/campaign/vnext/businesslocationfeed'],
  StyledFeeds: resourceMapping['/campaign/vnext/feeds'],
  StyledProductFeedPage: resourceMapping['/campaign/vnext/productfeed'],
  StyledLinkedStorePage: resourceMapping['/campaign/vnext/productfeed'],
  StyledBrandPage: resourceMapping['/campaign/vnext/productfeed'],
  StyledFeedSummaryPage: resourceMapping['/campaign/vnext/productfeed'],
  StyledTargetedLocations: resourceMapping['/campaign/vnext/settingscriterion'],
  StyledExcludedLocations: resourceMapping['/campaign/vnext/settingscriterion'],
  StyledAds: resourceMapping['/campaign/vnext/ads'],
  StyledAssets: resourceMapping['/campaign/vnext/assets'],
  StyledAssetsReport: resourceMapping['/campaign/vnext/assets-report'],
  StyledCombinations: resourceMapping['/campaign/vnext/combinations'],
  StyledLabels: resourceMapping['/campaign/vnext/labels'],
  StyledProducts: resourceMapping['/campaign/vnext/products'],
  ProductGroupsShell: resourceMapping['/campaign/vnext/productgroups'],
  StyledHotels: resourceMapping['/campaign/vnext/hotels'],
  StyleProperties: resourceMapping['/campaign/vnext/properties'],
  HotelGroupsShell: resourceMapping['/campaign/vnext/hotelgroups'],
  PropertyGroupsShell: resourceMapping['/campaign/vnext/propertygroups'],
  ListingGroupsShell: resourceMapping['/campaign/vnext/listinggroups'],
  BidStrategiesShell: resourceMapping['/campaign/vnext/bidstrategies'],
  PerformanceTargetsShell: resourceMapping['/campaign/vnext/performancetargets'],
  StyledAudienceAssociationPage: 'audience-associations/loader-ui-next',
  StyledPositiveKeywords: 'keywords/loader-ui-next',
  StyledNegativeKeywords: resourceMapping['/campaign/vnext/negative-keywords'],
  StyledAudienceAssociationCreation: 'audience/association/view/loader-ui-next',
  StyledAdSchedule: resourceMapping['/campaign/vnext/settingscriterion'],
  StyledOverview: resourceMapping['/campaign/vnext/overview'],
  StyledCampaignCreationSearch: 'campaign-create-advanced/loader-ui-next',
  StyledCampaignCreationSmartShopping: resourceMapping['/campaign/vnext/createcampaign/smartshopping'],
  StyledSearchterm: resourceMapping['/campaign/vnext/searchterms'],
  StyledAudiencesLibrary: resourceMapping['/campaign/vnext/audienceslibrary'],
  StyledAudienceCreation: resourceMapping['/campaign/vnext/audience/create'],
  StyledAudienceEdit: resourceMapping['/campaign/vnext/audience/create'],
  StyledConversionGoalsAutoCreate: resourceMapping['/campaign/vnext/conversiongoals/autocreate'],
  StyledConversionGoalsCreate: resourceMapping['/campaign/vnext/conversiongoals/create'],
  StyledConversionGoalsEdit: resourceMapping['/campaign/vnext/conversiongoals/create'],
  StyledUetTags: resourceMapping['/campaign/vnext/uettag'],
  StyledUetTestPage: resourceMapping['/campaign/vnext/uettagtest'],
  StyledUetWebInsights: resourceMapping['/campaign/vnext/uettaginsights'],
  StyledUetTagsCreate: resourceMapping['/campaign/vnext/uettags/create'],
  StyledUetTagsEdit: resourceMapping['/campaign/vnext/uettags/edit'],
  UniversalPixelUetTagCreate: resourceMapping['/campaign/vnext/uettagsup/create'],
  UniversalPixelUetTagEdit: resourceMapping['/campaign/vnext/uettagsup/edit'],
  StyledOfflineConversions: resourceMapping['/campaign/vnext/offlineconversions'],
  StyledModeledConversions: resourceMapping['/campaign/vnext/modeled-conversions'],
  StyledConversionGoals: resourceMapping['/campaign/vnext/conversiongoals'],
  StyledConversionValueRules: resourceMapping['/campaign/vnext/conversionvaluerules'],
  StyledConversionValueRulesCreate: resourceMapping['/campaign/vnext/conversionvaluerules/create'],
  StyledConversionValueRulesEdit: resourceMapping['/campaign/vnext/conversionvaluerules/edit'],
  StyledHotelCenter: resourceMapping['/campaign/vnext/hotelcenter'],
  StyledHotelCenterV2: resourceMapping['/campaign/vnext/propertycenter'],
  DemographicsShell: resourceMapping['/campaign/vnext/demographics'],
  DynamicAdTargets: resourceMapping['/campaign/vnext/dynamicadtargets'],
  StyledExperiments: resourceMapping['/campaign/vnext/experiments'],
  DimensionsShell: resourceMapping['/campaign/vnext/dimensions'],
  NegativeKeywordsListsShell: resourceMapping['/campaign/vnext/negativekeywordslists'],
  NegativeKeywordListsLibraryShell: resourceMapping['/campaign/vnext/negativekeywordslists'],
  NegativeKeywordsListsDetailsShell: resourceMapping['/campaign/vnext/negativekeywordslistsdetails'],
  StyledImportCenter: resourceMapping['/campaign/vnext/importcenter'],
  StyledLiftMeasurement: resourceMapping['/campaign/vnext/liftmeasurement'],
  StyledLiftMeasurementCreate: resourceMapping['/campaign/vnext/liftmeasurement/create'],
  StyledLiftMeasurementEdit: resourceMapping['/campaign/vnext/liftmeasurement/edit'],
  StyledLiftMeasurementResults: resourceMapping['/campaign/vnext/liftmeasurement/results'],
};

// TODO: this is a temporary solution to import highcharts if a page uses it.
// Consider two ways to get rid of this mapping and related logic:
//    1. Let HighchartReactWrapper to import accessibility module. (Highly recommended)
//    2. Find a way that webpack can shim highcharts when loading it.
export const bundlesUseHighcharts = {
  [resourceMapping['/campaign/vnext/accounts']]: true,
  [resourceMapping['/campaign/vnext/competitionauction']]: true,
  [resourceMapping['/campaign/vnext/campaigns']]: true,
  [resourceMapping['/campaign/vnext/adgroups']]: true,
  [resourceMapping['/campaign/vnext/settingscriterion']]: true,
  [resourceMapping['/campaign/vnext/changehistory']]: true,
  'recommendation/loader-ui-next': true,
  [resourceMapping['/campaign/vnext/keywordplanner']]: true,
  [resourceMapping['/campaign/vnext/competitionrecommendations']]: true,
  [resourceMapping['/campaign/vnext/productfeed']]: true,
  [resourceMapping['/campaign/vnext/ads']]: true,
  [resourceMapping['/campaign/vnext/products']]: true,
  [resourceMapping['/campaign/vnext/productgroups']]: true,
  [resourceMapping['/campaign/vnext/hotelgroups']]: true,
  [resourceMapping['/campaign/vnext/propertygroups']]: true,
  [resourceMapping['/campaign/vnext/performancetargets']]: true,
  'audience-associations/loader-ui-next': true,
  'keywords/loader-ui-next': true,
  [resourceMapping['/campaign/vnext/searchterms']]: true,
  [resourceMapping['/campaign/vnext/overview']]: true,
  [resourceMapping['/campaign/vnext/demographics']]: true,
  [resourceMapping['/campaign/vnext/dynamicadtargets']]: true,
  [resourceMapping['/campaign/vnext/merchantcenter']]: true,
  [resourceMapping['/campaign/vnext/overview']]: true,
};

const HotelCampaignCreation = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "hotel-campaign-creation-page" */'../feature-bootstrap/hotel-campaign-creation-page').then(getDefaultExport), false, true);
const StyledCompetitionAuctionInsight = () => importAfterPreLoad(bundles.StyledCompetitionAuctionInsight, () => import(/* webpackChunkName: "competition-auction-insight-page" */'../feature-bootstrap/competition-auction-insight-page').then(getDefaultExport), false, true);
const StyledSharedBudgetSummary = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "shared-budget-all-page" */'../feature-bootstrap/shared-budget-summary-page').then(getDefaultExport), false, true);
const StyledSharedBudgetEdit = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "shared-budget-all-page" */'../feature-bootstrap/shared-budget-edit-page').then(getDefaultExport), false, true);

const StyledPortfolioBidStrategy = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "portfolio-bid-strategy-page" */'../feature-bootstrap/portfolio-bid-strategy-page').then(getDefaultExport), true, true);

const StyledSeasonalityAdjustment = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "seasonality-adjustment-page" */'../feature-bootstrap/seasonality-adjustment-page').then(getDefaultExport), false, true);

const StyledBulkEdits = () => importAfterPreLoad(bundles.StyledBulkEdits, () => import(/* webpackChunkName: "bulk-edits-page" */'../feature-bootstrap/bulk-edits-page').then(getDefaultExport), false, true);
const StyledBulkEditsDetail = () => importAfterPreLoad(bundles.StyledBulkEditsDetail, () => import(/* webpackChunkName: "bulk-edits-page" */'../feature-bootstrap/bulk-edits-detail-page').then(getDefaultExport), false, true);
const MCMCampaignControl = () => importAfterPreLoad(bundles.MCMCampaignControl, () => import(/* webpackChunkName: "mcm-campaign-control-page" */'../feature-bootstrap/mcm-campaign-control-page').then(getDefaultExport), false, true);

const StyledImportSchedule = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "import-schedule-page" */'../feature-bootstrap/import-schedule-page').then(getDefaultExport), false, true);

const importScriptsCommon = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "scripts-common" */'../feature-bootstrap/scripts-common'), false, true);

const StyledScripts = () => importScriptsCommon().then(getDefaultExport).then(defaultExport => defaultExport.ScriptsPage);
const StyledScriptsHistory = () => importScriptsCommon().then(getDefaultExport).then(defaultExport => defaultExport.ScriptHistoryPage);
const StyledScriptsLogs = () => importScriptsCommon().then(getDefaultExport).then(defaultExport => defaultExport.ScriptLogsPage);
const StyledScriptsEdit = () => importScriptsCommon().then(getDefaultExport).then(defaultExport => defaultExport.ScriptsEditPage);

const BulkUploadsShell = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "bulk-uploads-page" */'../feature-bootstrap/bulk-uploads-page').then(getDefaultExport), false, true);

const StyledAdGroups = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "ad-groups-page" */'../feature-bootstrap/ad-groups-page').then(getDefaultExport), true, true);

const StyledSettingsForm = () => importAfterPreLoad(bundles.StyledSettingsForm, () => import(/* webpackChunkName: "settings-form-page" */'../feature-bootstrap/settings-form-page').then(getDefaultExport), false, true);

const StyledDevices = () => importAfterPreLoad(bundles.StyledDevices, () => import(/* webpackChunkName: "devices-page" */'../feature-bootstrap/devices-page').then(getDefaultExport), true, true);

const RecommendationsShell = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "recommendations-page" */'../feature-bootstrap/recommendations-page').then(getDefaultExport), true, true);

const StyledChangeHistory = () => importAfterPreLoad(bundles.StyledChangeHistory, () => import(/* webpackChunkName: "change-history-page" */'../feature-bootstrap/change-history-page').then(getDefaultExport), true, true);

const StyledCompetitionRecommendations = () => importAfterPreLoad(bundles.StyledCompetitionRecommendations, () => import(/* webpackChunkName: "competition-recommendations-page" */'../feature-bootstrap/competition-recommendations-page').then(getDefaultExport), false, true);

const StyledGmbImport = () => importAfterPreLoad(bundles.StyledGMBImport, () => import(/* webpackChunkName: "gmb-import-page" */'../feature-bootstrap/gmb-import-page').then(getDefaultExport), false, true);

const StyledFeeds = () => importAfterPreLoad(bundles.StyledFeeds, () => import(/* webpackChunkName: "feeds-page" */'../feature-bootstrap/feeds-page').then(getDefaultExport), false, true);

const StyledProductFeedPage = () => importAfterPreLoad(bundles.StyledProductFeedPage, () => import(/* webpackChunkName: "product-feed-page" */'../feature-bootstrap/product-feed-page').then(getDefaultExport), false, true);

const StyledLinkedStorePage = () => importAfterPreLoad(bundles.StyledLinkedStorePage, () => import(/* webpackChunkName: "linked-store-page" */'../feature-bootstrap/linked-store-page').then(getDefaultExport), false, true);

const StyledBrandPage = () => importAfterPreLoad(bundles.StyledBrandPage, () => import(/* webpackChunkName: "brand-page" */'../feature-bootstrap/brand-page').then(getDefaultExport), false, true);

const StyledFeedSummaryPage = () => importAfterPreLoad(bundles.StyledFeedSummaryPage, () => import(/* webpackChunkName: "feed-summary-page" */'../feature-bootstrap/feed-summary-page').then(getDefaultExport), false, true);

const StyledTargetedLocations = () => importAfterPreLoad(bundles.StyledTargetedLocations, () => import(/* webpackChunkName: "targeted-locations-page" */'../feature-bootstrap/targeted-locations-page').then(getDefaultExport), false, true);

const StyledExcludedLocations = () => importAfterPreLoad(bundles.StyledExcludedLocations, () => import(/* webpackChunkName: "excluded-locations-page" */'../feature-bootstrap/excluded-locations-page').then(getDefaultExport), false, true);

const StyledAds = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "ad-page" */'../feature-bootstrap/ads-page').then(getDefaultExport), true, true);

const StyledAssets = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "assets-page" */'../feature-bootstrap/assets-page').then(getDefaultExport), true, true);

const StyledAssetsReport = () => importAfterPreLoad(bundles.StyledAssetsReport, () => import(/* webpackChunkName: "assets-report-page" */'../feature-bootstrap/assets-report-page').then(getDefaultExport), false, true);

const StyledCombinations = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "combinations-page" */'../feature-bootstrap/combinations-page').then(getDefaultExport), true, true);

const StyledLabels = () => importAfterPreLoad(bundles.StyledLabels, () => import(/* webpackChunkName: "labels-page" */'../feature-bootstrap/labels-page').then(getDefaultExport), false, true);

const StyledProducts = () => importAfterPreLoad(bundles.StyledProducts, () => import(/* webpackChunkName: "products-page" */'../feature-bootstrap/products-page').then(getDefaultExport), false, true);

const StyledHotels = () => importAfterPreLoad(bundles.StyledHotels, () => import(/* webpackChunkName: "hotels-page" */'../feature-bootstrap/hotels-page').then(getDefaultExport), false, true);

const StyledProperties = () => importAfterPreLoad(bundles.StyledProperties, () => import(/* webpackChunkName: "properties-page" */'../feature-bootstrap/hotels-page').then(getDefaultExport), false, true);

const HotelGroupsShell = () => importAfterPreLoad(bundles.HotelGroupsShell, () => import(/* webpackChunkName: "hotel-groups-page" */'../feature-bootstrap/hotel-groups-page').then(getDefaultExport), false, true);

const PropertyGroupsShell = () => importAfterPreLoad(bundles.PropertyGroupsShell, () => import(/* webpackChunkName: "property-groups-page" */'../feature-bootstrap/hotel-groups-page').then(getDefaultExport), false, true);

const BidStrategiesShell = () => importAfterPreLoad(bundles.BidStrategiesShell, () => import(/* webpackChunkName: "bid-strategies-page" */'../feature-bootstrap/bid-strategies-page').then(getDefaultExport), false, true);

const ProductGroupsShell = () => importAfterPreLoad(bundles.ProductGroupsShell, () => import(/* webpackChunkName: "products-page" */'../feature-bootstrap/product-groups-page').then(getDefaultExport), false, true);

const PerformanceTargetsShell = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "performance-targets-page" */'../feature-bootstrap/performance-targets-page').then(getDefaultExport), true, true);

const StyledAudienceAssociationPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "audiences-page" */'../feature-bootstrap/audiences-page').then(getDefaultExport), true, true);

const StyledPositiveKeywords = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "positive-keywords-page" */'../feature-bootstrap/positive-keywords-page').then(getDefaultExport), true, true);

const StyledNegativeKeywords = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "negative-keywords-page" */'../feature-bootstrap/negative-keywords-page').then(getDefaultExport), false, true);

const StyledAudienceAssociationCreation = () => importAfterPreLoad(bundles.StyledAudienceAssociationCreation, () => import(/* webpackChunkName: "audience-association-creation" */'../feature-bootstrap/audience-association-creation').then(getDefaultExport), false, true);

const StyledAdSchedule = () => importAfterPreLoad(bundles.StyledAdSchedule, () => import(/* webpackChunkName: "ad-schedule-page" */'../feature-bootstrap/ad-schedule-page').then(getDefaultExport), false, true);

const StyledAudienceNetworkPlanner = () => importAfterPreLoad([], () => import(/* webpackChunkName: "audience-network-planner-page" */'../feature-bootstrap/audience-network-planner-page').then(getDefaultExport), true, true);

const StyledAudiencesLibrary = () => importAfterPreLoad(bundles.StyledAudiencesLibrary, () => import(/* webpackChunkName: "audiences-library" */'../feature-bootstrap/audiences-library').then(getDefaultExport), false, true);

const StyledAudienceSignalManagement = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "audience-signal-management-grid" */'../feature-bootstrap/audience-signal-management-grid').then(getDefaultExport), false, true);

const StyledAudienceCustomSegmentsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "audience-custom-segments-page" */'../feature-bootstrap/audience-custom-segments-page').then(getDefaultExport), false, true);

const StyledAudienceCreation = () => importAfterPreLoad(bundles.StyledAudiencesLibrary, () => import(/* webpackChunkName: "audiences-library" */'../feature-bootstrap/audience-creation').then(getDefaultExport), false, true);

const StyledAudienceEdit = () => importAfterPreLoad(bundles.StyledAudiencesLibrary, () => import(/* webpackChunkName: "audiences-library" */'../feature-bootstrap/audience-creation').then(getDefaultExport), false, true);

const StyledUetTags = () => importAfterPreLoad(bundles.StyledUetTags, () => import(/* webpackChunkName: "uet-tags" */'../feature-bootstrap/uet-tags').then(getDefaultExport), false, true);

const StyledUetTestPage = () => importAfterPreLoad(bundles.StyledUetTestPage, () => import(/* webpackChunkName: "uet-tags" */'../feature-bootstrap/uet-tags-test').then(getDefaultExport), false, true);

const StyledUetWebInsights = () => importAfterPreLoad(bundles.StyledUetWebInsights, () => import(/* webpackChunkName: "uet-tags" */'../feature-bootstrap/uet-web-insights').then(getDefaultExport), false, true);

const StyledUetTagsCreate = () => importAfterPreLoad(bundles.StyledUetTags, () => import(/* webpackChunkName: "uet-tags" */'../feature-bootstrap/uet-tags-create').then(getDefaultExport), false, true);

const StyledUetTagsEdit = () => importAfterPreLoad(bundles.StyledUetTags, () => import(/* webpackChunkName: "uet-tags" */'../feature-bootstrap/uet-tags-create').then(getDefaultExport), false, true);

const UniversalPixelUetTagCreate = () => importAfterPreLoad(bundles.StyledUetTags, () => import(/* webpackChunkName: "uet-up-tags" */'../feature-bootstrap/uet-up-tags').then(getDefaultExport), false, true);

const UniversalPixelUetTagEdit = () => importAfterPreLoad(bundles.StyledUetTags, () => import(/* webpackChunkName: "uet-up-tags" */'../feature-bootstrap/uet-up-tags').then(getDefaultExport), false, true);

const DemographicsShell = () => importAfterPreLoad(bundles.DemographicsShell, () => import(/* webpackChunkName: "demographics-page" */'../feature-bootstrap/demographics-page').then(getDefaultExport), false, true);

const StyledManagement = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "management-page" */'../feature-bootstrap/management-page').then(getDefaultExport), false, true);

const StyledRequests = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "requests-page" */'../feature-bootstrap/requests-page').then(getDefaultExport), false, true);

const StyledNotifications = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "notifications-page" */'../feature-bootstrap/notifications-page').then(getDefaultExport), false, true);

const StyledAccountLevelImportTab = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "account-import-page" */'../feature-bootstrap/account-import-page').then(getDefaultExport), false, true);

const AccountCreation = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "account-creation" */'../feature-bootstrap/account-creation').then(getDefaultExport), false, true);

const AccountLinking = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "account-linking" */'../feature-bootstrap/account-linking').then(getDefaultExport), false, true);

const AccountsTransfer = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "accounts-transfer" */'../feature-bootstrap/accounts-transfer').then(getDefaultExport), false, true);

const PendingTransferRequest = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "pending-transfer-request" */'../feature-bootstrap/pending-transfer-request').then(getDefaultExport), false, true);

const AccountsUnlinking = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "accounts-unlinking" */'../feature-bootstrap/accounts-unlinking').then(getDefaultExport), false, true);

const Reports = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "reports" */'../feature-bootstrap/reports-requirejs').then(getDefaultExport), false, true);

const ReportsV4 = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "reports-v4-page" */'../feature-bootstrap/reports-v4-page').then(getDefaultExport), false, true);

const StyledCustomReportingPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "custom-reports-page" */'../feature-bootstrap/custom-reports-page').then(getDefaultExport), false, true);

const StyledExperiments = () => importAfterPreLoad(bundles.StyledExperiments, () => import(/* webpackChunkName: "experiments-page" */'../feature-bootstrap/experiments-page').then(getDefaultExport), false, true);

const StyledSearchterm = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "search-term-page" */'../feature-bootstrap/search-term-page').then(getDefaultExport), true, true);

const DimensionsShell = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "dimensions-page" */'../feature-bootstrap/dimensions-page').then(getDefaultExport), false, true);

const CampaignDimensionShell = () => importAfterPreLoad(bundles.DimensionsShell, () => import(/* webpackChunkName: "common-dimension-page" */'../feature-bootstrap/campaign-dimension-page').then(getDefaultExport), false, true);

const SiteExclusionListCustomerCreationShell = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "site-exclusion-list-all-pages" */'../feature-bootstrap/site-exclusion-list-customer-creation-shell').then(getDefaultExport), false, true);

const SiteExclusionListCustomerEditPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "site-exclusion-list-all-pages" */'../feature-bootstrap/site-exclusion-list-customer-edit-page').then(getDefaultExport), false, true);

const SiteExclusionListAccountLevelListPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "site-exclusion-list-all-pages" */'../feature-bootstrap/site-exclusion-list-account-level-list-page').then(getDefaultExport), false, true);

const SiteExclusionListAccountLevelExclusionsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "site-exclusion-list-all-pages" */'../feature-bootstrap/site-exclusion-list-account-level-exclusions-page').then(getDefaultExport), false, true);

const WebsiteExclusionListsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "site-exclusion-list-all-pages" */'../feature-bootstrap/website-exclusion-lists-page').then(getDefaultExport), false, false);

const WebsiteExclusionListsCustomerEditPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "site-exclusion-list-all-pages" */'../feature-bootstrap/website-exclusion-lists-customer-edit-page').then(getDefaultExport), false, false);

const WebsiteExclusionListsAccountLevelListPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "site-exclusion-list-all-pages" */'../feature-bootstrap/website-exclusion-lists-account-level-list-page').then(getDefaultExport), false, false);

const WebsiteExclusionListsAccountLevelExclusionsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "site-exclusion-list-all-pages" */'../feature-bootstrap/website-exclusion-lists-account-level-exclusions-page').then(getDefaultExport), false, false);

const BrandSafetyPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "brand-safety-all-pages" */'../feature-bootstrap/brand-safety-page').then(getDefaultExport), false, true);

const StyledConversionGoals = () => importAfterPreLoad(bundles.StyledConversionGoals, () => import(/* webpackChunkName: "conversion-goals" */'../feature-bootstrap/conversion-goals').then(getDefaultExport), false, true);

const StyledConversionValueRules = () => importAfterPreLoad(bundles.StyledConversionValueRules, () => import(/* webpackChunkName: "conversion-value-rules" */'../feature-bootstrap/conversion-value-rules').then(getDefaultExport));

const StyledConversionValueRulesCreate = () => importAfterPreLoad(bundles.StyledConversionValueRulesCreate, () => import(/* webpackChunkName: "conversion-value-rules-create" */'../feature-bootstrap/conversion-value-rules-create').then(getDefaultExport));

const StyledConversionValueRulesEdit = () => importAfterPreLoad(bundles.StyledConversionValueRulesCreate, () => import(/* webpackChunkName: "conversion-value-rules-create" */'../feature-bootstrap/conversion-value-rules-create').then(getDefaultExport));

const StyledConversionGoalsAutoCreate = () => importAfterPreLoad(bundles.StyledConversionAutoGoals, () => import(/* webpackChunkName: "conversion-goals-auto-create" */'../feature-bootstrap/conversion-goals-auto-create').then(getDefaultExport));

const StyledConversionGoalsCreate = () => importAfterPreLoad(bundles.StyledConversionGoals, () => import(/* webpackChunkName: "conversion-goals" */'../feature-bootstrap/conversion-goals-create').then(getDefaultExport));

const StyledConversionGoalsEdit = () => importAfterPreLoad(bundles.StyledConversionGoals, () => import(/* webpackChunkName: "conversion-goals" */'../feature-bootstrap/conversion-goals-create').then(getDefaultExport), false, true);

const StyledHotelCenter = () => importAfterPreLoad(bundles.StyledHotelCenter, () => import(/* webpackChunkName: "hotel-center-page" */'../feature-bootstrap/hotel-center-page').then(getDefaultExport), false, true);

const StyledHotelCenterV2 = () => importAfterPreLoad(bundles.StyledHotelCenterV2, () => import(/* webpackChunkName: "hotel-center-v2-page" */'../feature-bootstrap/hotel-center-v2-page').then(getDefaultExport), false, true);

const StyledOfflineConversions = () => importAfterPreLoad(bundles.StyledOfflineConversions, () => import(/* webpackChunkName: "offline-conversions" */'../feature-bootstrap/offline-conversions').then(getDefaultExport), false, true);

const StyledCustomerAcquisition = () => importAfterPreLoad(bundles.StyledCustomerAcquisition, () => import(/* webpackChunkName: "customer-acquisition" */'../feature-bootstrap/customer-acquisition').then(getDefaultExport), false, true);

const StyledModeledConversions = () => importAfterPreLoad(bundles.StyledModeledConversions, () => import(/* webpackChunkName: "modeled-conversions" */'../feature-bootstrap/modeled-conversions').then(getDefaultExport), false, true);

const StyledKeywordPlanner = () => importAfterPreLoad(bundles.StyledKeywordPlanner, () => import(/* webpackChunkName: "keyword-planner" */'../feature-bootstrap/keyword-planner').then(getDefaultExport), false, true);

const StyledAdPreview = () => importAfterPreLoad(bundles.StyledAdPreview, () => import(/* webpackChunkName: "ad-preview" */'../feature-bootstrap/ad-preview').then(getDefaultExport), false, true);

const StyledAdInsightKeywordPlanner = () => importAfterPreLoad(bundles.StyledAdInsightKeywordPlanner, () => import(/* webpackChunkName: "keyword-planner" */'../feature-bootstrap/keyword-planner').then(getDefaultExport), false, true);

const StyledAdInsightAdPreview = () => importAfterPreLoad(bundles.StyledAdInsightAdPreview, () => import(/* webpackChunkName: "ad-preview" */'../feature-bootstrap/ad-preview').then(getDefaultExport), false, true);

const MerchantCenterShell = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "merchant-center-page" */'../feature-bootstrap/merchant-center-page').then(getDefaultExport), true, true);

const NegativeKeywordsLists = () => importAfterPreLoad(bundles.NegativeKeywordsListsShell, () => import(/* webpackChunkName: "negative-keywords-lists-page" */'../feature-bootstrap/negative-keywords-lists-page').then(getDefaultExport), false, true);

const NegativeKeywordListsLibrary = () => importAfterPreLoad(bundles.NegativeKeywordListsLibraryShell, () => import(/* webpackChunkName: "negative-keyword-lists-library-page" */'../feature-bootstrap/negative-keyword-lists-library-page').then(getDefaultExport), false, true);

const NegativeKeywordListsDetailsPage = () => importAfterPreLoad(bundles.NegativeKeywordsListsDetailsShell, () => import(/* webpackChunkName: "negative-keywords-lists-details-page" */'../feature-bootstrap/negative-keywords-lists-details-page').then(getDefaultExport), false, true);

const StyledImportCenter = () => importAfterPreLoad(bundles.StyledImportCenter, () => import(/* webpackChunkName: "import-center-page" */'../feature-bootstrap/import-center-page').then(getDefaultExport), false, true);

const StyledAutomatedRuleOperation = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "automated-rule-operation-page" */'../feature-bootstrap/automated-rule-operation-page').then(getDefaultExport), false, true);

const StyledAutomatedRuleDetail = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "automated-rule-operation-page" */'../feature-bootstrap/automated-rule-detail-page').then(getDefaultExport), false, true);

const StyledAutomatedRuleHistory = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "automated-rule-operation-page" */'../feature-bootstrap/automated-rule-history-page').then(getDefaultExport), false, true);

const StyledAccountSettingsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "account-settings-page" */'../feature-bootstrap/account-settings-page').then(getDefaultExport), false, true);

const StyledCampaignCreationSmartShopping = () => importAfterPreLoad(bundles.StyledCampaignCreationSmartShopping, () => import(/* webpackChunkName: "smart-shopping-campaign-creation-page" */'../feature-bootstrap/smart-shopping-campaign-creation-page').then(getDefaultExport), false, true);

const StyledOptOutOfMinorsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "optout-of-minors-page" */'../feature-bootstrap/optout-of-minors-page').then(getDefaultExport), false, true);

const {
  StyledDynamicAdTarget,
  DynamicExclusionShell,
  StyledDynamicSearchTerm,
} = pickManyImports(
  ['StyledDynamicAdTarget',
    'DynamicExclusionShell',
    'StyledDynamicSearchTerm',
  ],
  () => importAfterPreLoad(bundles.DynamicAdTargets, () => import(/* webpackChunkName: "dynamicadtargets-page" */'../feature-bootstrap/dynamic-ad-target-page').then(getDefaultExport))
);

const ChooseObjectiveWithLegacyConfig = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "choose-objective-page" */'../feature-bootstrap/choose-objective-page').then(getDefaultExport), false, true);

const CampaignOnboardingV2 = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "campaign-onboarding-v2-page" */'../feature-bootstrap/campaign-onboarding-v2-page').then(getDefaultExport), false, false);

const {
  StyledCampaignCreationSearch,
  StyledCampaignCreationAudience,
  StyledCampaignCreationAudienceVideo,
  StyledCampaignCreationSearchShopping,
  StyledCampaignCreationAudienceShopping,
  AdGroupCreationWithCampaign,
  StyledCampaignCreationAudienceSimplified,
  StyledCampaignCreationMSStoreAds,
  StyledCampaignCreationSearchShoppingWizard,
  StyledCampaignCreationAudienceShoppingWizard,
  StyledCampaignCreationSearchV2,
} = pickManyImportsWithLazyInit(
  ['StyledCampaignCreationSearch',
    'ChooseObjectiveWithLegacyConfig',
    'StyledCampaignCreationAudience',
    'StyledCampaignCreationAudienceVideo',
    'StyledCampaignCreationSearchShopping',
    'StyledCampaignCreationAudienceShopping',
    'AdGroupCreationWithCampaign',
    'StyledCampaignCreationAudienceSimplified',
    'StyledCampaignCreationMSStoreAds',
    'StyledCampaignCreationSearchShoppingWizard',
    'StyledCampaignCreationAudienceShoppingWizard',
    'StyledCampaignCreationSearchV2',
  ],
  () => importAfterPreLoad(null, () => import(/* webpackChunkName: "campaign-adgroup-creation" */'../feature-bootstrap/campaign-adgroup-creation').then(getDefaultExport), true, true)
);

const {
  PerfMaxCampaignCreationPage,
} = pickManyImportsWithLazyInit(
  ['PerfMaxCampaignCreationPage'],
  () => importAfterPreLoad(null, () => import(/* webpackChunkName: "perf-max-campaign-creation" */'../feature-bootstrap/perf-max-campaign-creation').then(getDefaultExport), true, true)
);

const {
  PerfMaxNorthStarWizard,
} = pickManyImportsWithLazyInit(
  ['PerfMaxNorthStarWizard'],
  () => importAfterPreLoad(null, () => import(/* webpackChunkName: "perf-max-north-star-campaign-creation" */'../feature-bootstrap/perf-max-north-star-campaign-creation').then(getDefaultExport), true, true)
);

const LinkedInCampaignCreationPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "linkedin-campain-creation" */'../feature-bootstrap/linkedin-campaign-creation').then(getDefaultExport), false, true);
const LinkedInAdEditorPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "linkedin-ad-editor" */'../feature-bootstrap/linkedin-ad-editor').then(getDefaultExport), false, true);

const StyledMSStoreAdsSellerIdsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "ms-store-ads" */'../feature-bootstrap/ms-store-ads-seller-ids-page').then(getDefaultExport), false, true);

const {
  StyledFacebookImport,
  StyledGoogleImport,
  StyledFileImport,
  StyledMultiAccountGoogleImport,
  StyledImportCredentialId,
} = pickManyImports(
  [
    'StyledFacebookImport',
    'StyledGoogleImport',
    'StyledFileImport',
    'StyledMultiAccountGoogleImport',
    'StyledImportCredentialId',
  ],
  () => importAfterPreLoad(null, () => import(/* webpackChunkName: "imports-shell" */'../feature-bootstrap/imports').then(getDefaultExport), false, true)
);

const StyledSmartGoogleImport = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "smart-imports-shell" */'../feature-bootstrap/smart-google-import-page').then(getDefaultExport), false, true);

const StyledAmazonImport = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "smart-imports-shell" */'../feature-bootstrap/amazon-import-page').then(getDefaultExport), false, true);

const StyledSmartFacebookImport = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "smart-imports-shell" */'../feature-bootstrap/smart-facebook-import-page').then(getDefaultExport), false, true);

const StyledPinterestImport = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "smart-imports-shell" */'../feature-bootstrap/pinterest-import-page').then(getDefaultExport), false, true);

const {
  StyledQueryInsightsOverviewPage,
  StyledQueryInsightsDetailsPage,
} = pickManyImports(
  [
    'StyledQueryInsightsOverviewPage',
    'StyledQueryInsightsDetailsPage',
  ],
  () => importAfterPreLoad(null, () => import(/* webpackChunkName: "query-insights" */'../feature-bootstrap/query-insights-page').then(getDefaultExport), true, true)
);

const CreativeStudioAssetLibraryPage = () => importAfterPreLoad(
  null,
  () => import(/* webpackChunkName: "creative-studio-asset-library" */'../feature-bootstrap/creative-studio-asset-library').then(getDefaultExport)
);

const AdsStudioPage = () => importAfterPreLoad(
  null,
  () => import(/* webpackChunkName: "asset-studio" */'../feature-bootstrap/ads-studio').then(getDefaultExport),
  true
);

const StyledAppAdsAssetGroupsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "appads-asset-groups-page" */'../feature-bootstrap/appads-asset-groups-page').then(getDefaultExport), false, true);


const StyledAssetGroupsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "asset-groups-page" */'../feature-bootstrap/asset-groups-page').then(getDefaultExport), false, true);

const StyledAssetGroupEditPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "asset-group-edit-page" */'../feature-bootstrap/asset-group-edit-page').then(getDefaultExport), false, true);

const StyledAssetGroupCreationPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "asset-group-create-page" */'../feature-bootstrap/asset-group-create-page').then(getDefaultExport), false, true);

const StyledUnifiedppAdsAssetGroupsCreationPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "unified-app-ads-asset-groups-creation-page" */'../feature-bootstrap/unified-app-ads-asset-groups-creation').then(getDefaultExport), false, true);

const ListingGroupsShell = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "listing-groups-page" */'../feature-bootstrap/listing-groups-page').then(getDefaultExport), false, true);

const StyledPmaxAssetsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "pmax-assets-page" */'../feature-bootstrap/pmax-assets-page').then(getDefaultExport), false, true);

const StyledPmaxCombinationsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "pmax-combinations-page" */'../feature-bootstrap/pmax-combinations-page').then(getDefaultExport), false, true);

const StyledPmaxNorthStarAssetGroupEditPage =
  () => importAfterPreLoad(null, () => import(/* webpackChunkName: "perf-max-north-star-asset-group-setting-edit-page" */'../feature-bootstrap/perf-max-north-star-asset-group-setting-edit-page').then(getDefaultExport), false, true);

const StyledXandrVideoCampaignCreationPage =
  () => importAfterPreLoad(null, () => import(/* webpackChunkName: "xandr-video-campaign-creation" */'../feature-bootstrap/xandr-video-campaign-creation').then(getDefaultExport), false, true);

const StyledXandrDisplayAdsCampaignCreationPage =
  () => importAfterPreLoad(null, () => import(/* webpackChunkName: "xandr-display-ads-campaign-creation" */'../feature-bootstrap/xandr-display-ads-campaign-creation').then(getDefaultExport), false, true);

const StyledDisplayPlusCampaignsPage =
  () => importAfterPreLoad(null, () => import(/* webpackChunkName: "display-plus-campaigns-page" */'../feature-bootstrap/display-plus-campaigns').then(getDefaultExport));

const StyledAppAdsCampaignsPage =
  () => importAfterPreLoad(null, () => import(/* webpackChunkName: "app-ads-campaigns-page" */'../feature-bootstrap/app-ads-campaigns').then(getDefaultExport));

const StyledAppAdsAssetGroupCreation =
  () => importAfterPreLoad(null, () => import(/* webpackChunkName: "appads-asset-groups-creation" */'../feature-bootstrap/appads-asset-groups-creation').then(getDefaultExport));

const CampaignBudgetToolPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "campaign-budget-tool-page" */'../feature-bootstrap/campaign-budget-tool-page').then(getDefaultExport));

const BudgetCenterPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "budget-center-page" */'../feature-bootstrap/budget-center-page').then(getDefaultExport), true, true);

const SponsoredCampaignCreationPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "sponsored-campaign-creation-page" */'../feature-bootstrap/sponsored-campaign-creation-page').then(getDefaultExport));

const StyledBrandListsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "brand-lists-page" */'../feature-bootstrap/brand-lists-page').then(getDefaultExport));

const StyledBrandListsDetailsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "brand-lists-details-page" */'../feature-bootstrap/brand-lists-details-page').then(getDefaultExport));

const StyledLiftMeasurementPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "lift-measurement-page" */'../feature-bootstrap/lift-measurement-page').then(getDefaultExport));

const StyledLiftMeasurementCreatePage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "lift-measurement-create-page" */'../feature-bootstrap/lift-measurement-create-page').then(getDefaultExport));

const StyledLiftMeasurementEditPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "lift-measurement-edit-page" */'../feature-bootstrap/lift-measurement-edit-page').then(getDefaultExport));

const StyledLiftMeasurementResultsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "lift-measurement-results-page" */'../feature-bootstrap/lift-measurement-results-page').then(getDefaultExport));

const StyledUnifiedAppAdsCampaignPage =
  () => importAfterPreLoad(null, () => import(/* webpackChunkName: "unified-app-ads-campaigns-page" */'../feature-bootstrap/unified-app-ads-campaigns').then(getDefaultExport));

const StyledUnifiedAppAdsAssetsPage = () => importAfterPreLoad(null, () => import(/* webpackChunkName: "unified-app-ads-assets-page" */'../feature-bootstrap/unified-app-ads-assets-page').then(getDefaultExport), false, true);

export const routes = {
  StyledSharedBudgetSummary,
  StyledSharedBudgetEdit,
  StyledPortfolioBidStrategy,
  StyledSeasonalityAdjustment,
  StyledCompetitionAuctionInsight,
  StyledBulkEdits,
  StyledBulkEditsDetail,
  MCMCampaignControl,
  StyledAdGroups,
  StyledSettingsForm,
  StyledDevices,
  RecommendationsShell,
  StyledChangeHistory,
  StyledCompetitionRecommendations,
  StyledGmbImport,
  StyledFeeds,
  StyledImportCenter,
  StyledProductFeedPage,
  StyledLinkedStorePage,
  StyledBrandPage,
  StyledFeedSummaryPage,
  StyledTargetedLocations,
  StyledExcludedLocations,
  StyledAds,
  StyledAssets,
  StyledAssetsReport,
  StyledCombinations,
  StyledLabels,
  StyledProducts,
  StyledHotels,
  StyledProperties,
  HotelGroupsShell,
  PropertyGroupsShell,
  ProductGroupsShell,
  PerformanceTargetsShell,
  StyledAudienceAssociationPage,
  StyledAudienceAssociationCreation,
  StyledPositiveKeywords,
  StyledNegativeKeywords,
  StyledAdSchedule,
  HotelCampaignCreation,
  StyledCampaignCreationSearch,
  StyledCampaignCreationSearchV2,
  ChooseObjectiveWithLegacyConfig,
  CampaignOnboardingV2,
  StyledCampaignCreationAudience,
  StyledCampaignCreationAudienceSimplified,
  StyledCampaignCreationAudienceVideo,
  StyledCampaignCreationSearchShopping,
  StyledCampaignCreationAudienceShopping,
  StyledCampaignCreationSearchShoppingWizard,
  StyledCampaignCreationAudienceShoppingWizard,
  AdGroupCreationWithCampaign,
  StyledCampaignCreationSmartShopping,
  PerfMaxCampaignCreationPage,
  PerfMaxNorthStarWizard,
  LinkedInCampaignCreationPage,
  LinkedInAdEditorPage,
  StyledXandrVideoCampaignCreationPage,
  StyledXandrDisplayAdsCampaignCreationPage,
  StyledDisplayPlusCampaignsPage,
  StyledAppAdsCampaignsPage,
  StyledAppAdsAssetGroupCreation,
  StyledUnifiedppAdsAssetGroupsCreationPage,
  StyledAudienceNetworkPlanner,
  StyledAudiencesLibrary,
  StyledAudienceSignalManagement,
  StyledAudienceCustomSegmentsPage,
  StyledAudienceCreation,
  StyledAudienceEdit,
  StyledManagement,
  StyledRequests,
  StyledNotifications,
  StyledAccountLevelImportTab,
  AccountCreation,
  AccountLinking,
  AccountsTransfer,
  PendingTransferRequest,
  AccountsUnlinking,
  StyledSearchterm,
  DemographicsShell,
  StyledDynamicAdTarget,
  DynamicExclusionShell,
  StyledDynamicSearchTerm,
  Reports,
  ReportsV4,
  StyledCustomReportingPage,
  DimensionsShell,
  StyledExperiments,
  CampaignDimensionShell,
  SiteExclusionListCustomerCreationShell,
  StyledImportSchedule,
  StyledScripts,
  StyledScriptsHistory,
  StyledScriptsEdit,
  StyledScriptsLogs,
  BulkUploadsShell,
  BidStrategiesShell,
  SiteExclusionListCustomerEditPage,
  WebsiteExclusionListsPage,
  WebsiteExclusionListsCustomerEditPage,
  WebsiteExclusionListsAccountLevelListPage,
  WebsiteExclusionListsAccountLevelExclusionsPage,
  StyledFacebookImport,
  StyledGoogleImport,
  StyledFileImport,
  StyledMultiAccountGoogleImport,
  StyledImportCredentialId,
  StyledUetTags,
  StyledUetWebInsights,
  StyledUetTestPage,
  StyledUetTagsCreate,
  StyledUetTagsEdit,
  UniversalPixelUetTagCreate,
  UniversalPixelUetTagEdit,
  StyledConversionGoals,
  StyledConversionValueRules,
  StyledConversionValueRulesCreate,
  StyledConversionValueRulesEdit,
  StyledConversionGoalsAutoCreate,
  StyledConversionGoalsCreate,
  StyledConversionGoalsEdit,
  StyledModeledConversions,
  StyledHotelCenter,
  StyledHotelCenterV2,
  StyledOfflineConversions,
  StyledCustomerAcquisition,
  StyledKeywordPlanner,
  StyledAdPreview,
  StyledAdInsightKeywordPlanner,
  StyledAdInsightAdPreview,
  MerchantCenterShell,
  StyledAutomatedRuleOperation,
  StyledAutomatedRuleHistory,
  SiteExclusionListAccountLevelListPage,
  StyledAutomatedRuleDetail,
  NegativeKeywordsLists,
  NegativeKeywordListsLibrary,
  SiteExclusionListAccountLevelExclusionsPage,
  BrandSafetyPage,
  StyledAccountSettingsPage,
  NegativeKeywordListsDetailsPage,
  StyledSmartGoogleImport,
  StyledOptOutOfMinorsPage,
  StyledAmazonImport,
  StyledSmartFacebookImport,
  StyledPinterestImport,
  StyledQueryInsightsOverviewPage,
  StyledQueryInsightsDetailsPage,
  CreativeStudioAssetLibraryPage,
  AdsStudioPage,
  StyledAssetGroupsPage,
  StyledAssetGroupEditPage,
  StyledAssetGroupCreationPage,
  ListingGroupsShell,
  StyledPmaxAssetsPage,
  StyledPmaxCombinationsPage,
  StyledMSStoreAdsSellerIdsPage,
  StyledCampaignCreationMSStoreAds,
  CampaignBudgetToolPage,
  BudgetCenterPage,
  SponsoredCampaignCreationPage,
  StyledBrandListsPage,
  StyledBrandListsDetailsPage,
  StyledAppAdsAssetGroupsPage,
  StyledLiftMeasurementPage,
  StyledLiftMeasurementCreatePage,
  StyledLiftMeasurementEditPage,
  StyledLiftMeasurementResultsPage,
  StyledUnifiedAppAdsCampaignPage,
  StyledUnifiedAppAdsAssetsPage,
  StyledPmaxNorthStarAssetGroupEditPage,
};
